var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrap"},[_c('rap-header'),_c('div',{staticClass:"main-content"},[_c('el-main',[_c('router-view')],1),_c('rap-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }